import {
    IComponentBlocksAltContent,
    IComponentBlocksCardsBlock,
    IComponentBlocksCarouselBlock,
    IComponentBlocksCarouselStories,
    IComponentBlocksContacts,
    IComponentBlocksCustomerRadarFeedbackBlock,
    IComponentBlocksDealsBlock,
    IComponentBlocksEmbedHtml,
    IComponentBlocksEnquiryForm,
    IComponentBlocksFaq,
    IComponentBlocksGallery,
    IComponentBlocksGalleryCarousel,
    IComponentBlocksIconCardBlock,
    IComponentBlocksMap,
    IComponentBlocksMotorhomeDetails,
    IComponentBlocksMotorhomeInfoTabs,
    IComponentBlocksRichText,
    IComponentBlocksRichTextColumns,
    IComponentBlocksSocialMedia,
    IComponentBlocksStarStoryForm,
    IComponentBlocksStoryCardGrid,
    IComponentBlocksTabContentBlock,
    IComponentBlocksTestimonials,
    IComponentBlocksVideo,
} from '@/graphql/__generated__/global/types';
import classNames from '@/lib/classNames';
import dynamic from 'next/dynamic';
import BlockEmbedHtml from './EmbedHtml/EmbedHtml';
import { BlockMotorhomeDetails } from './MotorhomeDetails/MotorhomeDetails';
import BlockStarStoryForm from './StarStoryForm/StarStoryForm';
import { TabContentBlock } from './TabContent/TabContent';

const AlternatingMediaWithContentBlock = dynamic(() => import('./AlternatingMediaWithContent/AlternatingMediaWithContentBlock'));
const BlocksCarousel = dynamic(() => import('./Carousel/Carousel'));
const BlocksCarouselStories = dynamic(() => import('./CarouselStories/CarouselStories'));
const BlockGalleryCarousel = dynamic(() => import('./GalleryCarousel/GalleryCarousel'));
const BlockDeals = dynamic(() => import('./Deals/Deals'));

const BlockEnquiryForm = dynamic(() => import('./EnquiryForm/EnquiryForm'));
const BlocksFaq = dynamic(() => import('./Faq/Faq'));
const BlockGallery = dynamic(() => import('./Gallery/Gallery'));

const BlockMotorhomeInfoTabs = dynamic(() => import('./MotorhomeInfoTabs/MotorhomeInfoTabs'));
const BlockRichText = dynamic(() => import('./RichText/RichText'));
const BlockRichTextColumns = dynamic(() => import('./RichTextColumns/RichTextColumns'));
const BlockSocialMedia = dynamic(() => import('./SocialMedia/SocialMedia'));

const BlockStoryCardGrid = dynamic(() => import('./StoryCardGrid/StoryCardGrid'));
const BlockTestimonials = dynamic(() => import('./Testimonials/Testimonials'));
const BlockVideo = dynamic(() => import('./VideoBlock/VideoBlock'));
const CardsBlock = dynamic(() => import('./Cards'));
const ContactColumns = dynamic(() => import('./ContactColumns/ContactColumns'));
const CustomerRadarBlock = dynamic(() => import('./CustomerRadarFeedback/CustomerRadarBlock'));

const IconCardBlock = dynamic(() => import('./IconCards/IconCardBlock'));
const Map = dynamic(() => import('./Map/Map'));

type BlockBuilderProps =
    | IComponentBlocksCardsBlock
    | IComponentBlocksCarouselBlock
    | IComponentBlocksCustomerRadarFeedbackBlock
    | IComponentBlocksDealsBlock
    | IComponentBlocksStoryCardGrid
    | IComponentBlocksTabContentBlock
    | IComponentBlocksMotorhomeDetails
    | IComponentBlocksMotorhomeInfoTabs
    | IComponentBlocksCarouselStories
    | IComponentBlocksContacts
    | IComponentBlocksFaq
    | IComponentBlocksGallery
    | IComponentBlocksMap
    | IComponentBlocksRichText
    | IComponentBlocksSocialMedia
    | IComponentBlocksStoryCardGrid
    | IComponentBlocksTestimonials
    | IComponentBlocksEnquiryForm
    | IComponentBlocksVideo
    | IComponentBlocksRichTextColumns
    | IComponentBlocksGalleryCarousel
    | IComponentBlocksAltContent
    | IComponentBlocksStarStoryForm
    | IComponentBlocksEmbedHtml
    | IComponentBlocksAltContent
    | IComponentBlocksIconCardBlock;

export const getBlockComponent = (block: BlockBuilderProps, index: number) => {
    let Block;

    const { __typename, ...rest } = block;

    switch (__typename) {
        case 'ComponentBlocksCardsBlock':
            Block = CardsBlock as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksCarouselBlock':
            Block = BlocksCarousel as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksCarouselStories':
            Block = BlocksCarouselStories as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksContacts':
            Block = ContactColumns as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksCustomerRadarFeedbackBlock':
            Block = CustomerRadarBlock as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksDealsBlock':
            Block = BlockDeals as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksEmbedHtml':
            Block = BlockEmbedHtml as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksEnquiryForm':
            Block = BlockEnquiryForm as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksFaq':
            Block = BlocksFaq as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksGallery':
            Block = BlockGallery as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksGalleryCarousel':
            Block = BlockGalleryCarousel as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksMap':
            Block = Map as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksMotorhomeDetails':
            Block = BlockMotorhomeDetails as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksMotorhomeInfoTabs':
            Block = BlockMotorhomeInfoTabs as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksRichText':
            Block = BlockRichText as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksRichTextColumns':
            Block = BlockRichTextColumns as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksSocialMedia':
            Block = BlockSocialMedia as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksStoryCardGrid':
            Block = BlockStoryCardGrid as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksTabContentBlock':
            Block = TabContentBlock as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksTestimonials':
            Block = BlockTestimonials as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksVideo':
            Block = BlockVideo as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksAltContent':
            Block = AlternatingMediaWithContentBlock as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksStarStoryForm':
            Block = BlockStarStoryForm as React.ComponentType<BlockBuilderProps>;
            break;

        case 'ComponentBlocksIconCardBlock':
            Block = IconCardBlock as React.ComponentType<BlockBuilderProps>;
            break;

        default:
            console.warn(`Section couldn't be rendered`);
            if (process.env.NODE_ENV !== 'production') {
                return <p>{JSON.stringify(block, null, 2)}</p>;
            }

            break;
    }

    return Block ? <Block key={`index-${index}`} {...rest} /> : null;
};

const BlockBuilder = ({ blocks }: { blocks: BlockBuilderProps[] }) => {
    return (
        <div>
            {blocks.map((block, index) => (
                <div
                    key={`index-${index}`}
                    className={classNames('py-8 lg:py-20', block.tightPaddingBelow && 'pb-8', index > 0 && blocks[index - 1] && blocks[index - 1].tightPaddingBelow && 'pt-2 lg:pt-8')}
                >
                    {getBlockComponent(block, index)}
                </div>
            ))}
        </div>
    );
};

export default BlockBuilder;
